import Production from '../src/Production/index';
export default Production;
